import React from 'react'
import { useState } from 'react';
import { useEffect } from 'react';
import {Link} from 'react-scroll';


const navStyle = {
    fontFamily: 'Montserrat Alternates, sans-serif',
    color: 'purple',
    listStyleType: 'none',
    margin: '0',
    padding: '0',
    overflow: 'hidden',
    display: 'flex',
    position: 'fixed',
    backgroundColor: 'white',
    width: '100%',
    zIndex: '2'
}



let linkStyles = {margin: '50px', 
    textAlign: 'center', 
    display: 'block',
    cursor: 'pointer'
}



const Nav = (props) => {

    const [change, setChange] = useState('false');

    useEffect(() => {
        if (change === 'true') {
            props.myfunction('true')
        }
    })

    const handleClick = () => {
        setChange('true')
    }

    return (


            <ul style={navStyle}>

                <Link style={linkStyles} to={"title"} smooth duration={1000}>{"Title"}</Link>
                <Link style={linkStyles} to={"about"} smooth duration={1000}>{"About"}</Link>
                <Link onClick={handleClick} style={linkStyles} to={"projects"} smooth duration={1000}>{"Projects"}</Link>


            </ul>



    )
}


export default Nav